import React, { Component } from 'react';
import { Modal, Empty, Select, Spin } from 'antd';
import Storage from '../../services/local-store';
import { LoadingOutlined, SearchOutlined,UpOutlined,DownOutlined } from '@ant-design/icons';
import './multiple_units.scss';


const { Option } = Select

class Multiple_units_switch extends Component {
    constructor(props) {
        super(props);
       
        this.state = {
            "active_unit": null,
            openDropdown: false
        }
    }

    componentDidMount() {
        var userData = JSON.parse(Storage.get('user_data'));
        this.setState({ "active_unit": userData ? userData['unitid'] : null }, () => this.getMapped_UnitsOfUser())
    }
    handleDropdownToggle = () => {
        this.setState(prevState => ({ openDropdown: !prevState.openDropdown }));
      };

    getMapped_UnitsOfUser(date) {        
        let all_tokens = Storage.get("all_tokens");
        let all_tokens_details = all_tokens && JSON.parse(all_tokens);
        let newData = [];
        if (all_tokens_details && all_tokens_details.length !== 0) {
            all_tokens_details.map((rdata, rKey) => {
                newData.push({
                    'id': rdata['unit_id'],
                    'name': rdata['unit_name'],
                    displayname: rdata['display_name'],
                })
            })
        }
        this.setState((state) => ({ 'mappedUnits': newData }));
    }

    unit_change = (e) => {
        let all_tokens = JSON.parse(Storage.get('all_tokens'));
        let all_user_data = JSON.parse(Storage.get('all_user_data'));
        let current_user= null
        all_tokens.map((data, key) => {
            if (data['unit_id'] == e) {
                current_user = all_user_data.find(o => o.unitid == e);
                Storage.store("user_data", current_user);
                Storage.store("current_Unit", data);
                Storage.store("token", data['token']);
                Storage.store("display_name", data['display_name']);
            }
        })
        this.setState({ "active_unit": e }) 
       
        Modal.info({
            title: 'Processing',
            content: 'Please wait. Your request is being processed. Do not refresh or close your browser',
           
        })      
        setTimeout(() => { this.gotoDasahboard(current_user); window.location.reload() }, 1000)
    }

    gotoDasahboard(current_user) {                
        // let user_data = JSON.parse(Storage.get("user_data"))
        let role_id = current_user && current_user["roleid"]
        // Super admin, admin
        role_id && (role_id === "RL_ijmN" || role_id === "RL_uxwJ") &&
            this.props.history.push(`/dashboard`)
        // Technician
        role_id && (role_id === "RL_qjrf") &&
            this.props.history.push(`/queue/technician-view`)
        // Operator
        role_id && (role_id === "RL_dNpj") &&
            this.props.history.push(`/queue/operator-view`)
        // Doctor
        role_id && (role_id === "RL_fGhl") &&
            this.props.history.push(`/queue/doctor-view`)
        // Vitals
        role_id && (role_id === "RL_L4fj") &&
            this.props.history.push(`/queue/vitals-view`)
        // Biller
        role_id && (role_id === "RL_Rco9") &&
            this.props.history.push(`/queue/biller-view`)
        // Token Generator
        role_id && (role_id === "RL_J88m") &&
            this.props.history.push(`/queue/token-generator`)
    }    

    render() {
        let { mappedUnits, fetching, active_unit } = this.state;
        const { openDropdown } = this.state;
    //     <style>
    //     {`
    //       .css-dev-only-do-not-override-1okl62o.ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
    //         background-color: #8c2ba4 !important; /* Background color */
    //         color: white; /* Text color */
    //       }
    //     `}
    //   </style>
    
        return (<React.Fragment>
            {/* <b className='my-auto mr-1'>Unit </b> */}
   

            <Select
                showSearch
                placeholder="Select a Unit"
                optionFilterProp="children"
                placement='bottomRight'
                defaultValue={active_unit ? active_unit : null}
                value={active_unit ? active_unit : null}                
                onChange={(e) => { this.unit_change(e) }}
                // notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                notFoundContent={fetching ? 
                
                <Spin indicator={<LoadingOutlined style={{ fontSize: '14px' }} spin />} />
                 : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                 style={{ width: '100%' }}
                // style={{ width: '100%' }}
                className="multiple-unit"
                dropdownStyle={{ width: '15%' }}
                // suffixIcon={<SearchOutlined style={{ transform: 'rotate(180deg)' }} />} // Rotate the search icon
    //             suffixIcon={this.state.dropdownOpen ? <UpOutlined /> : <DownOutlined />} // Change the icon based on dropdown state
    // onDropdownVisibleChange={(open) => { this.setState({ dropdownOpen: open }) }} // Update dropdown state
>

            
                {mappedUnits && mappedUnits.map((data, key) => {
                    return <Option key={key} value={data['id']}>{data['displayname']}</Option>
                })}
            </Select>
           

 
      {/* <Select
        showSearch
        placeholder="Select a Unit"
        optionFilterProp="children"
        placement="bottomRight"
        defaultValue={active_unit ? active_unit : null}
        value={active_unit ? active_unit : null}
        onChange={(e) => {
          this.unit_change(e);
        }}
        notFoundContent={
          fetching ? (
            <Spin indicator={<LoadingOutlined style={{ fontSize: '14px' }} spin />} />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )
        }
        style={{ width: '100%' }}
        className="multiple-unit"
        dropdownStyle={{ width: '15%' }}
        suffixIcon={
          openDropdown ? (
            <UpOutlined style={{ cursor: 'pointer' }} onClick={this.handleDropdownToggle} />
          ) : (
            <SearchOutlined style={{ cursor: 'pointer' }} onClick={this.handleDropdownToggle} />
          )
        }
      >
        {mappedUnits &&
          mappedUnits.map((data, key) => {
            return <Option key={key} value={data['id']}>{data['displayname']}</Option>;
          })}
      </Select>
     */}

      

        </React.Fragment>);
    }
}

export default Multiple_units_switch;